import React from "react";
import { Button } from "@mui/material";

const FileUploader = ({ accept = ".csv,.xlsx", onUpload }) => {
  const handleFileChange = (e) => {
    const file = e.target.files[0];
    if (file) onUpload(file);
  };

  return (
    <Button variant="outlined" component="label" sx={{ mb: 2 }}>
      Upload File
      <input hidden type="file" accept={accept} onChange={handleFileChange} />
    </Button>
  );
};

export default FileUploader;
